module.exports = __webpack_public_path__ + "img/address.4e71c1b9.png";